// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ZniH","messages":"Chat_messages__1lONN","dateDivider":"Chat_dateDivider__1B72W"};